import React from "react";
import { Box } from "@mui/material";
import PunchActionButtons from "./PunchActionButtons";
import { BRAND } from "../styles/authTheme";

const MobilePunchDock = ({
  visible,
  punchStatus,
  hasValidEmployee,
  loadingStatus,
  punching,
  onPunchIn,
  onPunchOut,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <Box
      sx={{
        display: { xs: "block", md: "none" },
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        px: 1.5,
        pt: 1.25,
        pb: "calc(12px + env(safe-area-inset-bottom, 0px))",
        bgcolor: "rgba(255, 255, 255, 0.94)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        borderTop: `1px solid ${BRAND.border}`,
        boxShadow: "0 -8px 32px rgba(15, 23, 42, 0.1)",
      }}
    >
      <PunchActionButtons
        punchStatus={punchStatus}
        hasValidEmployee={hasValidEmployee}
        loadingStatus={loadingStatus}
        punching={punching}
        onPunchIn={onPunchIn}
        onPunchOut={onPunchOut}
        compact
      />
    </Box>
  );
};

export default MobilePunchDock;
